import React from 'react';
import usePlayfulTeacher from '@/hooks/usePlayfulTeacher';
import { CourseSchedule } from './Default/course-schedule';
import { CourseSchedulePlayful } from './Playful/course-schedule-playful';

function CourseScheduleRoot(props) {
  const isPlayfulTeacher = usePlayfulTeacher();

  return isPlayfulTeacher ? <CourseSchedulePlayful {...props} /> : <CourseSchedule {...props} />;
}

export { CourseScheduleRoot as CourseSchedule };
